import React from "react";
import { Box } from "@mui/material";
import { getDealLabel } from "../helpers/dealHelpers";

export default function DealChip({
  product,
  fontSize = "12px",
  backgroundColor = "#D81B60",
  color = "#fff",
}) {
  const label = getDealLabel(product);

  if (!label) return null;

  return (
    <Box
      sx={{
        display: "inline-flex",
        ml: "auto",
        alignItems: "center",
        justifyContent: "center",

        alignSelf: "flex-end",

        backgroundColor,
        color,

        px: 1.5,
        py: 0.35,

        borderRadius: "999px",

        fontWeight: 700,
        fontSize,

        lineHeight: 1,
        whiteSpace: "nowrap",

        minWidth: 58,
      }}
    >
      {label}
    </Box>
  );
}